/**
 * Strip invisible/control characters and normalize whitespace in an email.
 *
 * Paste from Word, browsers, or other clients can introduce characters that
 * look fine to humans (zero-width space, BOM, NBSP, soft hyphen, etc.) but
 * fail ZeroBounce syntax checks and SES delivery.
 *
 * Does not lowercase — callers that need case folding should do that separately.
 */
export const sanitizeEmail = (email: string | null | undefined): string => {
  if (!email) {
    return '';
  }

  return (
    email
      // Unicode control (Cc) and format (Cf): ZWSP, ZWNJ, BOM, soft hyphen, C0/C1, etc.
      .replace(/[\p{Cc}\p{Cf}]/gu, '')
      // Space-like characters that trim() alone may not fully neutralize mid-string.
      .replace(/[\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]/g, ' ')
      .trim()
  );
};
